import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { ColumnType } from "../../../../../constants/enums/grid-column-type-enum";
import { PageLimitOptions } from "../../../../../constants/pageLimit.constant";
import { useStore } from "../../../../../contexts/store-provider";
import useWindowDimensions, {
  getTableMaxHeight,
} from "../../../../../helpers/window-resize-helper";
import IPageInfo from "../../../../../models/ICommon";
import { ISorting } from "../../../../../models/ISorting";
import Grid, { getColumns } from "../../../../../shared-components/Grid/Grid";
import Pagination from "../../../../../shared-components/Grid/Pagination";
import LanguageSlider from "../../../../../shared-components/language-slider/language-slider";
import ShowBusinessTypeFilterSlider from "../../../../../shared-components/show-business-type-filter-slider/show-business-type-filter";
import Nodata from "../../../../../shared-components/no-data-svg/no-data-svg";

interface IProps {
  setVisiblity: () => void;
  id: number;
  showDeletePopup: boolean;
  deleteToggleHandler: () => void;
  onPageLimitChanged: (evt: React.ChangeEvent<HTMLSelectElement>) => void;
  pageLimit: number;
  pageInfo: IPageInfo;
  onPageChanged: (pageNumber: number) => void;
  disablePagination: boolean;
  sorting: ISorting;
  handleSortingChange: (accessor: string) => void;
  setSelectedId: React.Dispatch<React.SetStateAction<number>>;
  selectedId: number;
  setIsRefreshPage: () => void;
  editHandler: (row: { Id: number }) => void;
}

const BusinessTypeListView: React.FC<IProps> = (props: IProps) => {
  const { masterManagementStore } = useStore();
  const {
    id,
    setVisiblity,
    showDeletePopup,
    deleteToggleHandler,
    onPageLimitChanged,
    pageLimit,
    pageInfo,
    onPageChanged,
    disablePagination,
    setSelectedId,
    selectedId,
    setIsRefreshPage,
    editHandler,
  } = props;

  const { getAllBusinessTypeList, businessTypeSettingState } =
    masterManagementStore;

  const [data, setData] = useState<any[]>(getAllBusinessTypeList);
  const [sorting, setSorting] = useState<ISorting>({
    column: "userName",
    orderBy: "asc",
  });

  useEffect(() => {
    setData(() => getAllBusinessTypeList);
  }, [getAllBusinessTypeList, setData]);
  // const [filterData, setFilterData] = useState<any>({...filter});

  const { height, width } = useWindowDimensions();
  /**
   * This function shows the delete client confirmation popup component and sets the seleted client Id
   */
  const deleteClickHandler = (row: { Id: number }) => {
    setSelectedId(row.Id);
    deleteToggleHandler();
  };

  /**
   * This function deletes the rate by providing Id to the Api
   */

  const addIcons: Array<any> = [
    {
      handler: editHandler,
      icon: (
        <i className="bi bi-pencil"></i>
      ),
      key: "",
      title: "edit",
      className: "btn-primary btn-sm",
    },
    {
      handler: deleteClickHandler,
      icon: (
        <i className="bi bi-trash"></i>
      ),
      key: "",
      title: "delete",
      className: "btn-danger",
    },
  ];

  const columns = getColumns<any, number>([
    {
      columnType: ColumnType.Hidden,
      accessorKey: "Id",
    },
    {
      columnType: ColumnType.TextHeader,
      accessorKey: "TypeName",
      displayName: "business_type",
    },
    {
      columnType: ColumnType.TextHeader,
      accessorKey: "Description",
      displayName: "description",
    },
    {
      columnType: ColumnType.ActionsFormatter,
      icons: addIcons,
      displayName: "label_action",
    },
  ]);

  return (
    <React.Fragment>
      {/* {businessTypeSettingState.inProgress && <SpinnerLoader />} */}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="business_type_setting" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="various_settings" />
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <FormattedMessage id="business_type_setting" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <ul className="add-list">
              <li>
                <LanguageSlider />
              </li>
              <li>
                <ShowBusinessTypeFilterSlider />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Container fluid className="p-0 my-3">
        {data.length !== 0 ? (
          <div>
            <div
              className="table-responsive"
              style={getTableMaxHeight(height, width)}
              data-testid="table"
            >
              {data && (
                <Grid
                  data={data}
                  columns={columns}
                  isInProgress={businessTypeSettingState.inProgress}
                  hiddenColumns={["Id"]}
                />
              )}
            </div>

            {/* <Container fluid>
                  <Row className="tableFooter py-1">
                    <Col xs="3" className="d-flex">
                      <b className="text-white text-hidden-m mt-1 pt-1">
                        <FormattedMessage id="show" />:{" "}
                      </b>
                      <select
                        data-testid="pageSelect"
                        className="ms-2 from-control"
                        onChange={onPageLimitChanged}
                        value={pageLimit}
                      >
                        {PageLimitOptions.map((op) => (
                          <option key={op} value={op}>
                            {op}
                          </option>
                        ))}
                      </select>
                    </Col>

                    <Col className="d-flex justify-content-end" xs="9">
                      <Pagination
                        totalPages={pageInfo.totalPages}
                        pageLimit={pageLimit}
                        onPageChanged={onPageChanged}
                        disablePagination={disablePagination}
                        isRefreshPage={pageInfo.isRefreshPage}
                        setIsRefreshPage={setIsRefreshPage}
                      />
                    </Col>
                  </Row>
                </Container> */}
          </div>
        ) : (
          <div className="no_data_table">
            <div className="no_data w-100 text-capitalize text-center">
              {/* <img src={""} alt="NOData" className="NOData" /> */}
              <Nodata />
              <h1 className="fs-4 fw-semi-bold">
                <FormattedMessage id="message_no_datafound" />
              </h1>
            </div>
          </div>
        )}
      </Container>
    </React.Fragment>
  );
};

export default observer(BusinessTypeListView);
